import Axios from 'axios'
import store from '../store'
var qs = require('qs')

export default {
  getDesk4meUrl() {
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientId() {
    return store.getters['Client/clientId']
  },
  getEmployeeGroups() {
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups`)
  },
  getEmployeeGroup(groupId) {
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups/${groupId}`)
  },
  saveGroup(group) {
    if (group.id) {
      return Axios.put(`/api/v1/clients/${this.getClientId()}/employee-groups/${group.id}`, group)
    } else {
      return Axios.post(`/api/v1/clients/${this.getClientId()}/employee-groups`, group)
    }
  },
  deleteGroup(groupId, cancelFutureBookings) {
    return Axios.delete(`/api/v1/clients/${this.getClientId()}/employee-groups/${groupId}?cancelFutureBookings=${cancelFutureBookings}`)
  },
  getEmployeeGroupsFile(params) {
    let headers = {
      responseType: 'arraybuffer',
      ignoreGlobalCatch: true,
      params: { employeeGroupIds: params.selectedIds, exportId: params.exportId },
      'paramsSerializer': function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      },
    }
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups/files`, headers)
  },
  getEmployeeGroupsTempleteFile() {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups/files/template`, headers)
  },
  getEmployeeGroupsFileErrors(fileId) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups/files/${fileId}`, headers)
  },
  importEmployeeGroupsFile(file, cancelFutureBookings) {
    let fileForm = new FormData()
    fileForm.append('file', file)
    return Axios.post(`/api/v1/clients/${this.getClientId()}/employee-groups/files?cancelFutureBookings=${cancelFutureBookings}`, fileForm)
  },
  getEmployeesFromGroup(obj) {
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups/${obj.id}/employees?term=${obj.term}&pageNumber=${obj.pageNumber}&pageSize=${obj.pageSize}`)
  },
  saveEmployeesIntoGroup(groupId, obj) {
    return Axios.patch(`/api/v1/clients/${this.getClientId()}/employee-groups/${groupId}/employees`, obj)
  },
  getGroupInfo(groupId) {
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups/${groupId}/employees-management`)
  },
  getEmployeesInfo() {
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employees/info`)
  },
  getEmployeesOutsideGroup(obj) {
    return Axios.get(`/api/v1/clients/${this.getClientId()}/employee-groups/${obj.id}/employees/outside-group?pageNumber=${obj.pageNumber}&pageSize=${obj.pageSize}`)
  },
}
